import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import GoogleAuth from './components/GoogleAuth';
import AppleAuth from './components/AppleAuth';
import arisLogo from '../../Assets/icon/aris_logo.svg';
import { ReactComponent as EmailIcon } from '../../Assets/icon/email.svg';
import { ReactComponent as PhoneIcon } from '../../Assets/icon/phone.svg';

const RightSection = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const handleMethodSelect = (method) => {
    const queryString = searchParams.toString();
    const route = method === 'email' ? '/login/email' : '/login/phone';
    navigate(`${route}${queryString ? '?' + queryString : ''}`);
  };

  const handleOtpSuccess = () => {
    // Success handled in individual auth components
  };

  // Check for payment success from Stripe
  useEffect(() => {
    const paymentStatus = searchParams.get('payment');
    if (paymentStatus === 'success') {
      navigate('/login/qr');
    }
  }, [searchParams, navigate]);

  return (
    <div className="right-section">
      <div className = 'right-section-header'>
          <img src={arisLogo} alt="Aris" className="auth-logo" />
      </div>
      <div className="right-section-content">
        <div className='rs-content-header'>
          <h2 className="auth-main-title">Sign In</h2>
        </div>
        
        <div className="auth-method-buttons">
          <GoogleAuth onSuccess={handleOtpSuccess} />
          <AppleAuth onSuccess={handleOtpSuccess} />
          <button 
            className="auth-method-btn"
            onClick={() => handleMethodSelect('email')}
          >
            <EmailIcon style={{ width: '20px', height: '20px', marginRight: '8px' }} />
            <span style={{ flex: 1, textAlign: 'center' }}>Continue with Email</span>
          </button>
          <button 
            className="auth-method-btn"
            onClick={() => handleMethodSelect('phone')}
          >
            <PhoneIcon style={{ width: '24px', height: '24px', marginRight: '8px' }} />
            <span style={{ flex: 1, textAlign: 'center' }}>Continue with Mobile</span>
          </button>
        </div>
      </div>
      <div className='right-section-footer'>
        <p className="auth-footer">© 2026 Aristotle, Inc. All rights reserved. Patents pending.</p>
      </div>
    </div>
  );
};

export default RightSection;


